var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C15.9952 12.4163 12.4163 15.9952 8 16ZM1.6 8.1376C1.63785 11.6586 4.51289 14.4876 8.03403 14.4688C11.5552 14.4498 14.3996 11.59 14.3996 8.0688C14.3996 4.5476 11.5552 1.68782 8.03403 1.6688C4.51289 1.64997 1.63785 4.47901 1.6 8V8.1376ZM9.6 12H7.2V8.8H6.4V7.2H8.8V10.4H9.6V12ZM8.8 5.6H7.2V4H8.8V5.6Z",
    fill: "#6165DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/Info-blue.564df4726c69832df42506ca7ef5e6b1.svg";
export { ForwardRef as ReactComponent };